export default __webpack_public_path__ + "bcf0264cc2df4c48699413b17b697c9b.png";